import manageStoresSopAddCustomerImage from "../../../assets/images/manage-stores-sop/manage-stores-sop-add-customer.png";
import manageStoresSopAddStoreImage from "../../../assets/images/manage-stores-sop/manage-stores-sop-add-store.png";
import manageStoresSopAddSupplierImage from "../../../assets/images/manage-stores-sop/manage-stores-sop-add-supplier.png";
import manageStoresSopStoreCustomersImage from "../../../assets/images/manage-stores-sop/manage-stores-sop-store-customers.png";
import manageStoresSopStoreDetailsImage from "../../../assets/images/manage-stores-sop/manage-stores-sop-store-details.png";
import manageStoresSopStoreEmployeesImage from "../../../assets/images/manage-stores-sop/manage-stores-sop-store-employees.png";
import manageStoresSopStoreListImage from "../../../assets/images/manage-stores-sop/manage-stores-sop-store-list.png";
import manageStoresSopStoreSuppliersImage from "../../../assets/images/manage-stores-sop/manage-stores-sop-store-suppliers.png";

import type { ManageStoresSopImageConfig } from "../types";

export const MANAGE_STORES_SOP_IMAGES: Record<
  string,
  ManageStoresSopImageConfig
> = {
  "store-list": {
    src: manageStoresSopStoreListImage,
    altKey: "manage-stores-sop-image-store-list-alt",
    altFallback:
      "Store List page showing store names, status, and the Add Store button"
  },
  "add-store": {
    src: manageStoresSopAddStoreImage,
    altKey: "manage-stores-sop-image-add-store-alt",
    altFallback:
      "Add Store form with fields for name, contact details, and address"
  },
  "store-details": {
    src: manageStoresSopStoreDetailsImage,
    altKey: "manage-stores-sop-image-store-details-alt",
    altFallback:
      "Store Details tab showing store name, manager, contact, and address"
  },
  "store-employees": {
    src: manageStoresSopStoreEmployeesImage,
    altKey: "manage-stores-sop-image-store-employees-alt",
    altFallback:
      "Store Employees tab with employee list and Add New Employee button"
  },
  "store-customers": {
    src: manageStoresSopStoreCustomersImage,
    altKey: "manage-stores-sop-image-store-customers-alt",
    altFallback:
      "Store Customers tab with customer list and Add New Customer button"
  },
  "add-customer": {
    src: manageStoresSopAddCustomerImage,
    altKey: "manage-stores-sop-image-add-customer-alt",
    altFallback:
      "Add Customer form with name, type, phone, email, and address fields"
  },
  "store-suppliers": {
    src: manageStoresSopStoreSuppliersImage,
    altKey: "manage-stores-sop-image-store-suppliers-alt",
    altFallback:
      "Store Suppliers tab with supplier list and Add New Supplier button"
  },
  "add-supplier": {
    src: manageStoresSopAddSupplierImage,
    altKey: "manage-stores-sop-image-add-supplier-alt",
    altFallback:
      "Add Supplier form with name, contact details, and address fields"
  }
};
